
import * as angular from "angular";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import { ColourService } from "@services/colour.service";
import { JourneyService } from "@services/journey.service";
import { IMarkerEvents, IPolyline, IPolylineOptions } from "@typings/google.maps.angular";
import { IRouteStop } from "@components/planning/interfaces/IRouteStop";
import { PlannedRouteMapService } from "@tms/_services/planned-route-map.service";

interface IVeriMapRouteBindings {

    veriMap: IVeriMapComponent;

    routeStops: IRouteStop[];
    selectedStop: IRouteStop;
    markers: IGoogleMapsMarker<IRouteStop>[];

    onMarkerUpdate(args: { $marker: IGoogleMapsMarker<IRouteStop> });

    fit: boolean;
    readOnly: boolean;
}

class VeriMapRouteOldComponentController implements angular.IComponentController, IVeriMapRouteBindings {

    markerEvents: IMarkerEvents<IGoogleMapsMarker<IRouteStop>> = {
        dragend: (markerObj, eventName: string, marker: IGoogleMapsMarker<IRouteStop>) => {
            if (this.onMarkerUpdate) {
                //console.log("onmarkerupdate", marker);

                marker.options.position = { lat: markerObj.getPosition().lat(), lng: markerObj.getPosition().lng() };

                this.onMarkerUpdate({ $marker: marker });
            }
        }
    }

    veriMap: IVeriMapComponent;

    routeStops: IRouteStop[];
    selectedStop: IRouteStop;

    markers: IGoogleMapsMarker<IRouteStop>[] = [];

    onMarkerUpdate: (args: { $marker: IGoogleMapsMarker<IRouteStop> }) => void;

    fit: boolean;
    readOnly: boolean;

    polylines: IPolyline[] = [];

    static $inject = ["journeyService", "plannedRouteMapService", "colourService"];

    constructor(
        private readonly journeyService: JourneyService,
        private readonly plannedRouteMapService: PlannedRouteMapService,
        private readonly colourService: ColourService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (!this.veriMap.mapInitialised) {
            return;
        }

        if (onChangesObj["routeStops"]/* && this.routeStops*/) {
            //var fitMap = !onChangesObj["job"].previousValue || onChangesObj["job"].previousValue.Id != onChangesObj["job"].currentValue.Id;

            this.updateRouteDisplay();
            this.fitMap();
        }

        if (onChangesObj["markers"] && this.markers) {
            this.fitMap();
        }

        if (onChangesObj["selectedStop"]) {
            this.fitMap();
        }
    }

    $onInit(): void {
        this.veriMap.mapInitialisedPromise.then(map => {
            this.updateRouteDisplay();
            this.fitMap();
        });
    }

    updateRouteDisplay() {
        this.polylines = [];

        if (this.routeStops) {
            this.routeStops.forEach((routeStop, index) => {

                const polyline = this.createRoutePolyline(routeStop, index);

                if (polyline) {
                    this.polylines.push(polyline);

                    let offRoadPoly: IPolyline;

                    //if (index === 0) {
                    //    offRoadPoly = this.createRouteStopOffRoadPolyline(routeStop, polyline, true);
                    //    this.polylines.push(offRoadPoly);
                    //}

                    offRoadPoly = this.createRouteStopOffRoadPolyline(routeStop, polyline);
                    this.polylines.push(offRoadPoly);
                }
            });
        }

        this.updateMarkerIcons();
    }

    private createRoutePolyline(routeStop: IRouteStop, index: number): IPolyline {

        const latLngArray: google.maps.LatLng[] = [];

        if (!routeStop.LinePoints || routeStop.LinePoints.length === 0) {
            //console.error("No line points for RouteStop", routeStop);
            //return null;
            if (index != 0) {
                const routeStopPosition = this.getRouteStopCoords(routeStop);
                const nextStopPosition = this.getRouteStopCoords(this.routeStops[index + 1]);

                routeStop.LinePoints = [
                    [routeStopPosition.lat, routeStopPosition.lng],
                    [nextStopPosition.lat, nextStopPosition.lng]
                ];
            }
            else {
                return null;
            }
        }

        routeStop.LinePoints.forEach(x => {
            latLngArray.push(new google.maps.LatLng(x[0], x[1]));
        });

        //console.log("createRoutePolyline", routeStop, routeStop.LinePoints);

        const polylineOptions: IPolylineOptions = {
            stroke: {
                color: this.colourService.getColour(index, true).solidColour,
                weight: 4,
                opacity: 1//0.9,
                //events: events // - fill this in later when we have start and end points
            }
        }

        const polyline: IPolyline = {
            id: this.polylines.length,
            path: latLngArray,
            options: polylineOptions,
            data: routeStop
        };

        return polyline;
    }

    private createRouteStopOffRoadPolyline(routeStop: IRouteStop, basePolyline: IPolyline, isStartPoint = false): IPolyline {
        // This createa a dashed line from the road to the stop, if the stop isnt at that point, 
        // it helps to indicate that its off road

        const latLngArray: google.maps.LatLng[] = [];

        if (isStartPoint) {
            latLngArray.push(basePolyline.path[0]);
        }
        else {
            latLngArray.push(basePolyline.path[basePolyline.path.length - 1]);
        }

        if (routeStop.Geofence) {
            latLngArray.push(new google.maps.LatLng(routeStop.Geofence.Latitude, routeStop.Geofence.Longitude));
        }
        else if (routeStop.GeocodedAddress) {
            latLngArray.push(new google.maps.LatLng(routeStop.GeocodedAddress.CenterPoint.Latitude, routeStop.GeocodedAddress.CenterPoint.Longitude));
        }

        const options = angular.copy(basePolyline.options);
        options.stroke.opacity = 0;
        options.icons = [
            {
                icon: {
                    path: "M 0,-1 0,1",
                    strokeOpacity: 1,
                    scale: 2,
                    strokeWeight: 2
                },
                offset: "0",
                repeat: "10px"
            }
        ];

        const polyline: IPolyline = {
            id: this.polylines.length,
            path: latLngArray,
            options: options,
            data: routeStop
        };

        return polyline;
    }

    private updateMarkerIcons() {
        this.markers = [];

        if (!this.routeStops) {
            return;
        }

        this.routeStops.forEach((routeStop, index, visibleWaypoints) => {

            const markerOptions = this.plannedRouteMapService.createRouteMarkerOptions(routeStop, index, visibleWaypoints.length);

            markerOptions.draggable = !this.readOnly;

            markerOptions.position = this.getRouteStopCoords(routeStop);

            this.markers.push({
                id: index,
                options: markerOptions,
                model: routeStop
            });
        });
    }

    private getRouteStopCoords(stop: IRouteStop): google.maps.LatLngLiteral {

        if (stop.GeocodedAddress) {
            return {
                lat: stop.GeocodedAddress.CenterPoint.Latitude,
                lng: stop.GeocodedAddress.CenterPoint.Longitude
            }
        }
        else if (stop.Geofence) {
            return {
                lat: stop.Geofence.Latitude,
                lng: stop.Geofence.Longitude
            }
        }
    }

    private fitMap() {
        if (this.fit === false || (this.polylines.length === 0 && this.markers.length === 0)) {
            return;
        }

        if (this.selectedStop) {
            const coords = this.getRouteStopCoords(this.selectedStop);

            this.veriMap.fitMap([new google.maps.LatLng(coords)]);
            this.veriMap.getMap().setZoom(12);
        }
        else if (this.polylines.length > 0) {
            let latLngs: google.maps.LatLng[] = [];

            this.polylines.forEach(line => {
                latLngs = latLngs.concat(line.path);
            });

            this.veriMap.fitMap(latLngs);
        }
        else {

            this.veriMap.fitMap(this.markers.map(m => new google.maps.LatLng(m.options.position)));
        }
    }
}

export class VeriMapRouteOldComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            routeStops: "<",
            onMarkerUpdate: "&",
            readOnly: "<?",
            selectedStop: "<?",
            fit: "<"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = VeriMapRouteOldComponentController;
        this.template = require("./veriMapRoute.old.html");
    }
}
